import _classCallCheck from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _createForOfIteratorHelper from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { ViewPlugin, PluginField, EditorView } from '@codemirror/view';
import { Facet } from '@codemirror/state';
var panelConfig = /*@__PURE__*/Facet.define({
  combine: function combine(configs) {
    var topContainer, bottomContainer;

    var _iterator = _createForOfIteratorHelper(configs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var c = _step.value;
        topContainer = topContainer || c.topContainer;
        bottomContainer = bottomContainer || c.bottomContainer;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {
      topContainer: topContainer,
      bottomContainer: bottomContainer
    };
  }
});
/**
Configures the panel-managing extension.
*/

function panels(config) {
  return config ? [panelConfig.of(config)] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/


function getPanel(view, panel) {
  var plugin = view.plugin(panelPlugin);
  var index = plugin ? plugin.specs.indexOf(panel) : -1;
  return index > -1 ? plugin.panels[index] : null;
}

var panelPlugin = /*@__PURE__*/ViewPlugin.fromClass( /*#__PURE__*/function () {
  function _class(view) {
    _classCallCheck(this, _class);

    this.input = view.state.facet(showPanel);
    this.specs = this.input.filter(function (s) {
      return s;
    });
    this.panels = this.specs.map(function (spec) {
      return spec(view);
    });
    var conf = view.state.facet(panelConfig);
    this.top = new PanelGroup(view, true, conf.topContainer);
    this.bottom = new PanelGroup(view, false, conf.bottomContainer);
    this.top.sync(this.panels.filter(function (p) {
      return p.top;
    }));
    this.bottom.sync(this.panels.filter(function (p) {
      return !p.top;
    }));

    var _iterator2 = _createForOfIteratorHelper(this.panels),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var p = _step2.value;
        p.dom.classList.add("cm-panel");
        if (p.mount) p.mount();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  _createClass(_class, [{
    key: "update",
    value: function update(_update) {
      var conf = _update.state.facet(panelConfig);

      if (this.top.container != conf.topContainer) {
        this.top.sync([]);
        this.top = new PanelGroup(_update.view, true, conf.topContainer);
      }

      if (this.bottom.container != conf.bottomContainer) {
        this.bottom.sync([]);
        this.bottom = new PanelGroup(_update.view, false, conf.bottomContainer);
      }

      this.top.syncClasses();
      this.bottom.syncClasses();

      var input = _update.state.facet(showPanel);

      if (input != this.input) {
        var specs = input.filter(function (x) {
          return x;
        });
        var _panels = [],
            top = [],
            bottom = [],
            mount = [];

        var _iterator3 = _createForOfIteratorHelper(specs),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var spec = _step3.value;
            var known = this.specs.indexOf(spec),
                panel = void 0;

            if (known < 0) {
              panel = spec(_update.view);
              mount.push(panel);
            } else {
              panel = this.panels[known];
              if (panel.update) panel.update(_update);
            }

            _panels.push(panel);

            (panel.top ? top : bottom).push(panel);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.specs = specs;
        this.panels = _panels;
        this.top.sync(top);
        this.bottom.sync(bottom);

        for (var _i = 0, _mount = mount; _i < _mount.length; _i++) {
          var p = _mount[_i];
          p.dom.classList.add("cm-panel");
          if (p.mount) p.mount();
        }
      } else {
        var _iterator4 = _createForOfIteratorHelper(this.panels),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _p = _step4.value;
            if (_p.update) _p.update(_update);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.top.sync([]);
      this.bottom.sync([]);
    }
  }]);

  return _class;
}(), {
  provide: /*@__PURE__*/PluginField.scrollMargins.from(function (value) {
    return {
      top: value.top.scrollMargin(),
      bottom: value.bottom.scrollMargin()
    };
  })
});

var PanelGroup = /*#__PURE__*/function () {
  function PanelGroup(view, top, container) {
    _classCallCheck(this, PanelGroup);

    this.view = view;
    this.top = top;
    this.container = container;
    this.dom = undefined;
    this.classes = "";
    this.panels = [];
    this.syncClasses();
  }

  _createClass(PanelGroup, [{
    key: "sync",
    value: function sync(panels) {
      var _iterator5 = _createForOfIteratorHelper(this.panels),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var p = _step5.value;
          if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.panels = panels;
      this.syncDOM();
    }
  }, {
    key: "syncDOM",
    value: function syncDOM() {
      if (this.panels.length == 0) {
        if (this.dom) {
          this.dom.remove();
          this.dom = undefined;
        }

        return;
      }

      if (!this.dom) {
        this.dom = document.createElement("div");
        this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
        this.dom.style[this.top ? "top" : "bottom"] = "0";
        var parent = this.container || this.view.dom;
        parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
      }

      var curDOM = this.dom.firstChild;

      var _iterator6 = _createForOfIteratorHelper(this.panels),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var panel = _step6.value;

          if (panel.dom.parentNode == this.dom) {
            while (curDOM != panel.dom) {
              curDOM = rm(curDOM);
            }

            curDOM = curDOM.nextSibling;
          } else {
            this.dom.insertBefore(panel.dom, curDOM);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      while (curDOM) {
        curDOM = rm(curDOM);
      }
    }
  }, {
    key: "scrollMargin",
    value: function scrollMargin() {
      return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
  }, {
    key: "syncClasses",
    value: function syncClasses() {
      if (!this.container || this.classes == this.view.themeClasses) return;

      var _iterator7 = _createForOfIteratorHelper(this.classes.split(" ")),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var cls = _step7.value;
          if (cls) this.container.classList.remove(cls);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper((this.classes = this.view.themeClasses).split(" ")),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _cls = _step8.value;
          if (_cls) this.container.classList.add(_cls);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }]);

  return PanelGroup;
}();

function rm(node) {
  var next = node.nextSibling;
  node.remove();
  return next;
}

var baseTheme = /*@__PURE__*/EditorView.baseTheme({
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  }
});
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/

var showPanel = /*@__PURE__*/Facet.define({
  enables: [panelPlugin, baseTheme]
});
export { getPanel, panels, showPanel };